import React, { useEffect, useRef, useState } from "react";
import { Progress } from "react-sweet-progress";
import { htmlToText, trimString, tokenAuthorize } from "../Helpers/Common";
import "react-sweet-progress/lib/style.css";
import PinIcon from "../../common/images-new/pin.svg";
import moment from "moment";
import { serverUrl } from "../Helpers/Config";
import { getLearningMyTask } from "../../redux/actions/learningMyTask";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { staticFiles } from "../Helpers/Static";
import { BsPin, BsPinFill } from "react-icons/bs";
import { getLearningTask } from "../../redux/actions/learning";
import TimerOffIcon from '@mui/icons-material/TimerOff';
import TimerOffOutlinedIcon from '@mui/icons-material/TimerOffOutlined';
import {
  ActiveIconColor,
  ActiveSpanColor,
  ButtonCommonTopGrey,
  ButtonCommonTopNew,
  Card,
  MenuItemCard,
  MenuItemDiv,
  PinnedIcon,
  TextGray,
} from "../../pages/Theme";
import noprofile from "../../common/images-new/no-profile-pic.png";
import BoltIcon from "@mui/icons-material/Bolt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { BiSolidHourglass } from "react-icons/bi";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import PushPinIcon from "@mui/icons-material/PushPin";

const noProfile = noprofile;

const CHECKED_CIRCLE = staticFiles.checkedCircle;

const CardTask = ({ id, data, openModal, onClick, isMyTask }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const taskSliced = (
    data && data.tasks && data.tasks?.length > 0
      ? data.tasks?.sort((a, b) => a.task_order - b.task_order)
      : []
  )
    ? data.tasks.slice(0, 3)
    : [];

  const [dropdown, setDropdown] = useState(false);
  const [pinned, setPinned] = useState(data.pin_status);
  const popupRef = useRef();
  // const [todo, setTodo] = useState(data.tasks);
  // const [totalTask, setTotalTask] = useState(0);
  const [tutorGuid, setTutorGuid] = useState("");
  const [tutorProfile, setTutorProfile] = useState(null);

  const isSuccess = useSelector((state) => state.teaching.isSuccess);
  const isSuccessRef = useRef(isSuccess);
  const isDefaultTheme = useSelector((state) => state.auth.isDefaultTheme);
  const userTheme = useSelector((state) => state.auth.theme);

  const toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDropdown(!dropdown);
  };

  // useEffect(() => {
  //   const handleClick = (e) => {
  //     if (!popupRef.current.contains(e.target)) {
  //       setDropdown(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClick, false);
  //   return function cleanup() {
  //     document.removeEventListener("mousedown", handleClick, false);
  //   };
  // });

  // useEffect(() => {
  //   setPinned(data.pin_status)
  // }, [data])

  useEffect(() => {
    axios
      .get(serverUrl.Task + `/${data.id}`)
      .then((res) => {
        if (res.status === 200) {
          setTutorGuid(res.data?.tutor_guid);
          setTutorProfile(res.data?.tutor_profile);
        }
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status);
      });
  }, [data]);

  useEffect(() => {
    isSuccessRef.current = isSuccess;
  }, [isSuccess]);

  const addPin = (e) => {
    e.preventDefault();
    e.stopPropagation();
    axios.post(serverUrl.Learning + `/pin/${data.id}`).then((resp) => {
      if (resp.status === 200) {
        dispatch(getLearningTask());
      }
    });
  };

  const removePin = (e) => {
    e.preventDefault();
    e.stopPropagation();
    axios.delete(serverUrl.Learning + `/pin/${data.id}`).then((resp) => {
      if (resp.status === 200) {
        dispatch(getLearningTask());
      }
    });
  };

  const handleDelete = () => {
    Swal.fire({
      heightAuto: false,
      title: "Confirmation",
      text: "Are you sure to delete this task list?",
      icon: "warning",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Confirm",
      denyButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(serverUrl.LearningMyTask + `/${id}`)
          .then(() => {
            dispatch(getLearningMyTask());
            Swal.fire("Success", "Task list has been deleted", "success");
          })
          .catch((error) => {
            tokenAuthorize(error?.response?.status);
            Swal.close();
          });
      }
    });
  };

  const showComment = (e) => {
    e.preventDefault();
    e.stopPropagation();
    Swal.fire({
      heightAuto: false,
      title: "Tutor's Comment",
      html: data.comment,
    });
  };
  // const handleChange = (id) => {
  //   const updatedTodos = todo.map((todo) => {
  //     if (todo.id === id) {
  //       todo.completed = !todo.completed;
  //     }
  //     return todo
  //   });
  //   setTodo(updatedTodos);
  // }

  // useEffect(() => {
  //   setTotalTask(
  //     todo.filter((list) => list.completed === true).length
  //   )
  // }, [])

  const setOpenModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    openModal();
  };

  const formatModernDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short", // Jan, Feb, Mar, etc.
      day: "numeric", // 1, 2, 3...
    });
  };

  function getProgressPercent(startDate, endDate) {
    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();
    const today = new Date().getTime();

    if (isNaN(start) || isNaN(end)) return 0; // invalid dates
    if (end <= start) return 100; // avoid division by zero, treat as complete

    const total = end - start;
    const completed = today - start;

    const percent = (completed / total) * 100;

    return Math.min(100, Math.max(0, percent)); // clamp between 0–100
  }

  function getShortCode(name) {
    if (!name) return "";

    // Split by spaces
    const words = name.trim().split(/\s+/);

    if (words.length === 1) {
      // Single word → take first letter
      return words[0][0].toUpperCase();
    } else {
      // Multiple words → take first letter of first 2 words
      return (words[0][0] + words[1][0]).toUpperCase();
    }
  }

  const percentCompletion =
    data.task_done && data.task_count && data.task_count > 0
      ? Math.floor((data.task_done / data.task_count) * 100)
      : 0;

  const currentDate = new Date();
  return (
    <Card
      className="relative w-full flex flex-col border20px shadow-sm text-base text-black p-3 md:p-5 md:px-6  px-3 md:text-base"
      onClick={onClick}
    >
      {/* <div className="absolute z-10 w-20 h-20 -top-7 -left-7 md:w-32 md:h-32 md:-top-8 md:-left-8">
        {
          (data.task_count > 0) &&
          (data.task_count === data.task_done) &&
          <img src={CHECKED_CIRCLE} alt="completed" />
        }
      </div> */}
      <div className="mb-2 flex justify-between items-center">
        {currentDate > new Date(data.list_due) && (
          <p className="text-sm lightColor flex items-center gap-1">
            <TimerOffIcon
              className="-ml-1 deleteColor"
              style={{fontSize:'19px'}}
            />{" "}
            Expired
          </p>
        )}
        {currentDate < new Date(data.list_due) && (
          <>
            {data.task_count > 0 && data.task_count === data.task_done ? (
              <p className="text-sm lightColor flex items-center gap-1">
                <CheckCircleIcon
                  className="-ml-1"
                  style={{
                        color:
                          userTheme == "" || userTheme == "default theme"
                            ? "#66D692"
                            : userTheme?.color2,
                      }}
                />{" "}
                Completed
              </p>
            ) : (
              <p className="text-sm flex lightColor items-center">
                <BoltIcon className="blueColor -ml-1" /> Active
              </p>
            )}
            
          </>
        )}
        {isMyTask === false && (
              <PushPinIcon
                onClick={pinned === false ? addPin : removePin}
                style={{ fontSize: "24px" }}
                className={`iconHover ${
                  pinned ? "primaryIcon" : "secondaryIcon"
                }`}
              />
            )}
        {isMyTask === true && (
          <div
            ref={popupRef}
            onClick={toggleDropdown}
            className="cursor-pointer "
          >
            <svg
              className=" w-max h-6 -mr-3"
              fill="none"
              stroke="#C4C4C4"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
              />
            </svg>
            {dropdown && (
              <MenuItemCard className="absolute top-0 right-0 z-50 w-24 p-1 mt-2 transform -translate-x-4 translate-y-12 bg-white rounded-md md:w-32 lg:w-36 filter drop-shadow">
                <li className="pl-2 md:pb-2 text-black">
                  <MenuItemDiv
                    className="flex items-center cursor-pointer md:mt-2 hover:opacity-70 text-black"
                    onClick={() => history.push(`/tasks/edit/${id}`)}
                  >
                    <p className="text-sm">Edit</p>
                  </MenuItemDiv>
                  <MenuItemDiv
                    className="flex items-center cursor-pointer md:mt-2 hover:opacity-70 text-black"
                    onClick={handleDelete}
                  >
                    <p className="text-sm">Delete</p>
                  </MenuItemDiv>
                </li>
              </MenuItemCard>
            )}
          </div>
        )}
      </div>

      {/* <TextGray className="text-sm text-center text-gray-400 lg:text-md">
        {data.group_name && data.group_name.length > 0 ? trimString(data.group_name, 15) : "[No course group]"}
      </TextGray> */}
      {/* {isMyTask === true && (
        <div
          ref={popupRef}
          onClick={toggleDropdown}
          className="cursor-pointer absolute -right-5 -top-12 md:-right-2 md:-top-8"
        >
          <svg
            className="absolute w-6 h-6 top-10 right-5"
            fill="none"
            stroke="#C4C4C4"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
            />
          </svg>
          {dropdown && (
            <MenuItemCard className="absolute top-0 right-0 z-10 w-24 p-1 mt-6 transform -translate-x-4 translate-y-12 bg-white rounded-md md:w-32 lg:w-36 filter drop-shadow">
              <li className="pl-2 md:pb-2 text-black">
                <MenuItemDiv
                  className="flex items-center cursor-pointer md:mt-2 hover:opacity-70 text-black"
                  onClick={() => history.push(`/tasks/edit/${id}`)}
                >
                  <p className="text-sm">Edit</p>
                </MenuItemDiv>
                <MenuItemDiv
                  className="flex items-center cursor-pointer md:mt-2 hover:opacity-70 text-black"
                  onClick={handleDelete}
                >
                  <p className="text-sm">Delete</p>
                </MenuItemDiv>
              </li>
            </MenuItemCard>
          )}
        </div>
      )} */}

      {/* {isMyTask === false &&
        <div
          className='absolute flex flex-wrap content-center justify-center w-7 h-7 md:w-8 md:h-8 p-1 border border-gray-400 rounded-md shadow-sm cursor-pointer right-2 -top-3 lg:right-2 lg:top-0 xl:-top-2 md:w-7 md:h-7'
          onClick={pinned === false ? addPin : removePin}
        >
          {
            pinned ? <ActiveIconColor><BsPinFill className="w-5 h-5 md:w-6 md:h-6" /></ActiveIconColor> : <BsPin className="text-gray w-5 h-5 md:w-6 md:h-6" />
          }
        </div>
      } */}
      <div className="w-full mb-2.5">
        <p className=" blackColor font-semibold text-xl">{data.list_name}</p>
        {trimString(htmlToText(data.list_desc), 100) && (
          <div
            className="text-sm greyColor font-medium break-words multiline-ellipsis2 
          "
          >
            {htmlToText(data.list_desc)}
            {/* {trimString(htmlToText(data.list_desc), 100)} */}
          </div>
        )}
      </div>
      <div className="flex flex-col mb-2.5">
        <div className="w-full flex justify-between ">
          <span className="mr-1 text-md blackColor">Assigned on</span>
          <span className="text-md blackColor">Due on</span>
        </div>
        <div className="w-full my-2.5 px-3">
          <div className="relative w-full h-0.5 greyBackGroundColor rounded-full">
            {/* Progress fill */}
            <div
              className="absolute top-0 left-0 h-0.5 blueBackGroundColor"
              style={{
                width: `${getProgressPercent(
                  data.list_created,
                  data.list_due
                )}%`,
              }}
            />

            {/* Left end dot */}
            <div className="absolute -top-1.5 -left-3 -translate-y-1 z-10">
              <div className="w-3.5 h-3.5 rounded-full blueBackGroundColor flex items-center justify-center">
                <div className="w-2 h-2 rounded-full bg-white"></div>
              </div>
            </div>

            {/* Right end dot */}
            <div className="absolute -top-1.5 -right-3 -translate-y-1 z-10">
              <div className="w-3.5 h-3.5 rounded-full blueBackGroundColor flex items-center justify-center">
                <div className="w-2 h-2 rounded-full bg-white"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex justify-between">
          <span className="mr-1 text-sm greyColor">
            {formatModernDate(data.list_created)}
          </span>
          <span className="text-sm greyColor">
            {formatModernDate(data.list_due)}
          </span>
        </div>
      </div>
      {/* <hr className="" /> */}
      {/* <div className="font-semibold text-lg flex mb-1 blackColor">Tasks</div> */}
      <div className="flex flex-col items-center mb-3 taskPage">
        <div className="w-full flex justify-between mb-1 blackColor">
          {/* <span className="">Task completed</span> */}
          <span className="">
            {" "}
            {data.task_done}/{data.task_count}
          </span>
          <span>{percentCompletion}%</span>
        </div>
        <Progress
          percent={percentCompletion}
          status="success"
          symbol=""
          theme={{
            success: {
              // symbol: percentCompletion + "%",
              // symbol:'null',
              color: isDefaultTheme == false ? userTheme?.color2 : "#66D692",
            },
          }}
        />
      </div>
      {/* <div className="flex flex-col">
        {taskSliced.length > 0 &&
          taskSliced.map((list, index) => (
            <div key={index} className="flex mb-1.5 items-center">
              <div className="flex items-center">
                {list.response_status ? (
                  <CheckCircleIcon
                    style={{
                      color:
                        isDefaultTheme == false ? userTheme?.color2 : "#66D692",
                    }}
                  />
                ) : (
                  <BiSolidHourglass
                    style={{ fontSize: "18px", color: "#f97316" }}
                  />
                )}
              </div>
              <div
                className={"px-1.5 text-sm"}
                onClick={(event) => event.preventDefault()}
              >
                {list.task_name}
              </div>
            </div>
          ))}
        <span
          className="flex justify-center  cursor-pointer blueColor text-md"
          onClick={(e) => setOpenModal(e)}
        >
          {data.tasks.length > 3 && `view ${data.tasks.length - 3} more tasks`}
        </span>
      </div> */}
      <div className="flex flex-col pb-3">
        {data.comment && data.comment.length > 0 && (
          <span
            className="flex justify-center cursor-pointer blueColor text-md"
            onClick={showComment}
          >
            View tutor's comment
          </span>
        )}
      </div>
      {isMyTask === false && (data?.group_name || data?.tutor_name) && (
        <div className="flex items-center justify-between mt-auto">
          <div className="flex items-center gap-2 ">
            <div className="flex items-center">
              <ButtonCommonTopNew className="w-10 h-10 rounded-full flex items-center justify-center text-md font-semibold">
                {getShortCode(data.group_name || data.tutor_name)}
              </ButtonCommonTopNew>
            </div>
            <div className="flex flex-col ">
              {data.group_name && (
                <span className="text-md font-semibold blackColor">
                  {data.group_name}
                </span>
              )}
              {data.tutor_name && (
                <span className="text-sm blackColor flex gap-1.5">
                  <span className="greyColor font-normal"> by</span>{" "}
                  {data.tutor_name}
                </span>
              )}
            </div>
          </div>
          <ButtonCommonTopGrey className="w-10 h-10 rounded-full flex items-center justify-center text-md font-semibold">
            <KeyboardArrowRightIcon className="greyColor" />
          </ButtonCommonTopGrey>
        </div>
      )}
    </Card>
  );
};

export default CardTask;
